import React from 'react';
import Dialog from '@dashboard/components/Dialog';

/**
 * A confirmation in the standard Dialog. Use instead of the confirm() helper, which renders in a
 * separate root and leaves the page unclickable after closing.
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      cancelButton={{ label: cancelLabel, appearance: 'link' }}
      confirmButton={{
        label: confirmLabel,
        appearance: 'primary',
        onClick: () => {
          onOpenChange(false);
          onConfirm();
        },
      }}
    />
  );
}
